import './admin.scss';
import './plugin-settings/settings';

//import '../shared/ebc-datepicker.scss';
import { initFlatpickr } from '../shared/flatpickr-init';

jQuery(document).ready(function () {
	const $ = jQuery;

	const $multilingual = $('[name="devnet_ebc_general[multilingual]"]');
	const $textInputs = $(
		'input[type="text"][name^="devnet_ebc_"]:not([name^="devnet_ebc_form[list]"]), textarea[name^="devnet_ebc_"]'
	);

	if ($multilingual.is(':checked')) {
		$textInputs.addClass('disabled multilingual');
	} else {
		$textInputs.removeClass('disabled multilingual');
	}

	$textInputs.each(function () {
		if ($(this).hasClass('disabled multilingual')) {
			$(this).after(
				'<div class="devnet-visible-tooltip">Multilingual option is active!</div>'
			);
		}
	});

	initFlatpickr('[name="devnet_ebc_calendar[dates]"]', {
		isOpen: true,
		mode: 'multiple',
	});
});
